import { render, staticRenderFns } from "./AdvantagesOfSite.vue?vue&type=template&id=31af3cf7&scoped=true&"
import script from "./AdvantagesOfSite.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AdvantagesOfSite.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AdvantagesOfSite.vue?vue&type=style&index=0&id=31af3cf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af3cf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31af3cf7')) {
      api.createRecord('31af3cf7', component.options)
    } else {
      api.reload('31af3cf7', component.options)
    }
    module.hot.accept("./AdvantagesOfSite.vue?vue&type=template&id=31af3cf7&scoped=true&", function () {
      api.rerender('31af3cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/AdvantagesOfSite.vue"
export default component.exports